import React, { useState, useEffect } from "react"
import SweetAlert from "react-bootstrap-sweetalert"
import { getCurrentUser, getPermission } from "../../../helpers/Utils"
import { Link } from "react-router-dom"
import axios from "axios"
import SourceModal from "./SourceModal"
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

let selectedRoleId = []

const SourceList = props => {
  const [source, setSource] = useState(props.data)
  const [modal_lead_source, setmodal_lead_source] = useState(false)
  const [isOpen, setIsOpen] = useState(false)
  const [confirm_alert, setconfirm_alert] = useState(false)
  const [confirm_alert2, setconfirm_alert2] = useState(false)
  const [success_dlg, setsuccess_dlg] = useState(false)
  const [dynamic_title, setdynamic_title] = useState("")
  const [dynamic_description, setdynamic_description] = useState("")
  const [showDetails, setShowDetails] = useState(false)
  const [showDetails1, setShowDetails1] = useState(false)
  const [showDetails2, setShowDetails2] = useState(false)

  const toggleDetails = () => setShowDetails(prev => !prev)
  const toggleDetails1 = () => setShowDetails1(prev => !prev)
  const toggleDetails2 = () => setShowDetails2(prev => !prev)

  const deleteSource = e => {
    axios
      .delete(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/lead/source/${e}`,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          setSource("")
          setdynamic_description(res.data.message)
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
          props.getAllSources()
        }
      })
  }

  const deleteLeads = e => {
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/${localStorage.getItem(
          "company_name"
        )}/leadsource-lead-deleted/${e} `,
        {
          headers: {
            "content-type": "application/json",
            Authorization: `Bearer ${
              getCurrentUser().token == null ? "" : getCurrentUser().token
            }`,
          },
        }
      )
      .then(function (res) {
        if (res.data.status) {
          props.getAllSource()
          toast.success(res.data.message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          })
        }
      })
  }
  const editSource = e => {
    setIsOpen(true)
    setmodal_lead_source(true)
  }

  useEffect(() => {
    selectedRoleId = []
  }, [])

  const getSelectedId = (e, check) => {
    if (check.target.checked) {
      selectedRoleId.push(e)
      const uniqueID = selectedRoleId.filter((val, id, array) => {
        return array.indexOf(val) == id
      })
      selectedRoleId = uniqueID
      props.setLeadsSelectedIds(selectedRoleId)
    } else {
      selectedRoleId = props.leadsSelectedIds
      var array = selectedRoleId
      var index = array.indexOf(e)
      if (index !== -1) {
        array.splice(index, 1)
      }
      props.setLeadsSelectedIds(selectedRoleId)
    }
    if (selectedRoleId.length == 0) {
      props.setBlur(false)
    } else {
      props.setBlur(true)
    }
  }

  if (source === "") {
    return ""
  } else
    return (
      <>
        {isOpen ? (
          <SourceModal
            modal_lead_source={modal_lead_source}
            setmodal_lead_source={setmodal_lead_source}
            source={source}
            setSource={setSource}
            setIsOpen={setIsOpen}
          />
        ) : (
          ""
        )}
        <tr key={props.i}>
          <td>
            <input
              onChange={e => getSelectedId(source.id, e)}
              name="chk"
              value={source.id}
              className="p-0 d-inline-block"
              type="checkbox"
            />
          </td>
          <td>{props.counter + props.i}</td>
          <td>{source.id}</td>
          <td>{source.name}</td>
          <td>
            <Link
              className=""
              to={`/leads?lead_source_id=${source.id}&from_date=${props.fromDate}&to_date=${props.toDate}`}
            >
              {source.total}
            </Link>
          </td>

          <td style={{ background: "green", color: "white" }}>
            <Link
              className="text-light"
              to={`/leads?lead_source_id=${source.id}&type=matured&from_date=${props.fromDate}&to_date=${props.toDate}`}
            >
              {source.matured}
              <br />
              <small>
                (
                {source.total > 0
                  ? ((source.matured / source.total) * 100).toFixed(1)
                  : 0}
                %)
              </small>
            </Link>
          </td>
          <td>
            <div>
              <strong>
                {(
                  source.matured_amount + source.total_business
                ).toLocaleString()}{" "}
                total
              </strong>
              <br />
              <small>
                ({source.matured_amount.toLocaleString()} new +
                <br />
                {source.total_business.toLocaleString()} repeated)
              </small>
            </div>
          </td>
          <td style={{ background: "cyan" }}>
            <Link
              className=""
              to={`/leads?lead_source_id=${source.id}&type=new`}
            >
              {source.new}
              <br />
              <small>
                (
                {source.total > 0
                  ? ((source.new / source.total) * 100).toFixed(1)
                  : 0}
                %)
              </small>
            </Link>
          </td>
          <td style={{ width: "120px", minWidth: "120px", maxWidth: "120px" }}>
            <div className="d-flex align-items-center justify-content-center flex-column">
              <div className="d-flex align-items-center">
                <Link
                  to={`/leads?lead_source_id=${source.id}&type=followup`}
                  className="badge bg-warning text-dark me-2 fw-bold"
                  style={{ fontSize: "11px", textDecoration: "none" }}
                >
                  {source.followup[0] && source.followup[0].total}
                </Link>
                {source.followup &&
                  source.followup.filter(item => item.count > 0).length > 0 && (
                    <button
                      onClick={toggleDetails}
                      className="btn btn-sm p-0 expandable-counter"
                      style={{
                        background: "transparent",
                        fontSize: "10px",
                      }}
                      title="Click to expand/collapse"
                    >
                      {showDetails ? (
                        <i className="ti-angle-up text-dark"></i>
                      ) : (
                        <i className="ti-angle-down text-dark"></i>
                      )}
                    </button>
                  )}
              </div>
              <small className="text-muted">
                (
                {source.total > 0
                  ? (
                      ((source.followup[0] && source.followup[0].total) /
                        source.total) *
                      100
                    ).toFixed(1)
                  : 0}
                %)
              </small>
            </div>
          </td>
          <td
            style={{
              background: "#f14747",
              color: "white",
              width: "120px",
              minWidth: "120px",
              maxWidth: "120px",
            }}
          >
            <div className="d-flex align-items-center justify-content-center flex-column">
              <div className="d-flex align-items-center">
                <Link
                  to={`/leads?lead_source_id=${source.id}&type=dead`}
                  className="text-light me-2 fw-bold"
                  style={{ fontSize: "11px", textDecoration: "none" }}
                >
                  {source.dead[0] && source.dead[0].total}
                </Link>
                {source.dead &&
                  source.dead.filter(item => item.count > 0).length > 0 && (
                    <button
                      onClick={toggleDetails1}
                      className="btn btn-sm p-0 expandable-counter"
                      style={{
                        background: "transparent",
                        fontSize: "10px",
                      }}
                      title="Click to expand/collapse"
                    >
                      {showDetails1 ? (
                        <i className="ti-angle-up text-white"></i>
                      ) : (
                        <i className="ti-angle-down text-white"></i>
                      )}
                    </button>
                  )}
              </div>
              <small className="text-light">
                (
                {source.total > 0
                  ? (
                      ((source.dead[0] && source.dead[0].total) /
                        source.total) *
                      100
                    ).toFixed(1)
                  : 0}
                %)
              </small>
            </div>
          </td>
          <td
            style={{
              background: "orange",
              color: "white",
              width: "140px",
              minWidth: "140px",
              maxWidth: "140px",
            }}
          >
            <div className="d-flex align-items-center justify-content-center flex-column">
              <div className="d-flex align-items-center">
                <Link
                  to={`/leads?lead_source_id=${source.id}&type=dead_request`}
                  className="text-light me-2 fw-bold"
                  style={{ fontSize: "11px", textDecoration: "none" }}
                >
                  {source.dead_request[0] && source.dead_request[0].total}
                </Link>
                {source.dead_request &&
                  source.dead_request.filter(item => item.count > 0).length >
                    0 && (
                    <button
                      onClick={toggleDetails2}
                      className="btn btn-sm p-0 expandable-counter"
                      style={{
                        background: "transparent",
                        fontSize: "10px",
                      }}
                      title="Click to expand/collapse"
                    >
                      {showDetails2 ? (
                        <i className="ti-angle-up text-white"></i>
                      ) : (
                        <i className="ti-angle-down text-white"></i>
                      )}
                    </button>
                  )}
              </div>
              <small className="text-light">
                (
                {source.total > 0
                  ? (
                      ((source.dead_request[0] &&
                        source.dead_request[0].total) /
                        source.total) *
                      100
                    ).toFixed(1)
                  : 0}
                %)
              </small>
            </div>
          </td>
          <td style={{ background: "purple", color: "white" }}>
            <Link
              className="text-light"
              to={`/leads?lead_source_id=${source.id}&type=repeated`}
            >
              {source.repeated}
              <br />
              <small>
                (
                {source.total > 0
                  ? ((source.repeated / source.total) * 100).toFixed(1)
                  : 0}
                %)
              </small>
            </Link>
          </td>
          <td>{source.created_at}</td>
          <td>
            {getPermission().lead.lead.delete.is_checked === "yes" ? (
              <>
                <button
                  className="btn text-danger btn-link btn-sm mb-3"
                  onClick={e => setconfirm_alert2(true)}
                >
                  Delete Leads
                </button>{" "}
                <br />
              </>
            ) : (
              ""
            )}
            {getPermission().lead_source.lead_source.edit.is_checked ===
            "yes" ? (
              <a
                className="text-warning"
                onClick={() => {
                  editSource(source.id)
                }}
              >
                <i className="fas fa-pen" />
              </a>
            ) : (
              ""
            )}
            {getPermission().lead_source.lead_source.delete.is_checked ===
            "yes" ? (
              <a
                className="text-danger ms-2"
                onClick={() => {
                  setconfirm_alert(true)
                }}
              >
                <i className="fas fa-trash-alt" />
              </a>
            ) : (
              ""
            )}
            {confirm_alert ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert(false)
                  setsuccess_dlg(true)
                  deleteSource(source.id)
                  setdynamic_title("Deleted")
                  setdynamic_description("Your file has been deleted.")
                }}
                onCancel={() => setconfirm_alert(false)}
              >
                You won't be able to revert this!
              </SweetAlert>
            ) : null}
            {confirm_alert2 ? (
              <SweetAlert
                title="Are you sure?"
                warning
                showCancel
                confirmButtonText="Yes, delete it!"
                confirmBtnBsStyle="success"
                cancelBtnBsStyle="danger"
                onConfirm={() => {
                  setconfirm_alert2(false)
                  setsuccess_dlg(true)
                  deleteLeads(source.id)
                  setdynamic_title("Deleted")
                  setdynamic_description("Your file has been deleted.")
                }}
                onCancel={() => setconfirm_alert2(false)}
              >
                This will delete all related leads PERMANENTLY
              </SweetAlert>
            ) : null}
          </td>
        </tr>

        {/* Expanded rows for Followup statuses */}
        {showDetails &&
          source.followup &&
          source.followup.filter(item => item.count > 0).length > 0 && (
            <tr>
              <td
                colSpan="13"
                className="reason-badges"
                style={{
                  background: "#f8f9fa",
                  padding: "15px",
                }}
              >
                <div className="row">
                  <div className="col-12">
                    <strong className="text-warning mb-3 d-block fs-6 text-center">
                      Followup Statuses:
                    </strong>
                    <div className="d-flex flex-wrap justify-content-center">
                      {source.followup
                        .filter(item => item.count > 0)
                        .map((item, i) => (
                          <Link
                            key={i}
                            to={`/leads?lead_source_id=${source.id}&followup_status_id=${item.id}&from_date=${props.fromDate}&to_date=${props.toDate}`}
                            className="badge bg-warning text-dark mx-1 mb-2 d-flex flex-column align-items-center"
                            title={item.status}
                            style={{
                              fontSize: "11px",
                              textDecoration: "none",
                            }}
                          >
                            <span>
                              {item.count} {item.status}
                            </span>
                            <small style={{ fontSize: "9px", opacity: 0.8 }}>
                              (
                              {(source.followup[0] &&
                                source.followup[0].total) > 0
                                ? (
                                    (item.count / source.followup[0].total) *
                                    100
                                  ).toFixed(1)
                                : 0}
                              %)
                            </small>
                          </Link>
                        ))}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          )}

        {/* Expanded rows for Dead reasons */}
        {showDetails1 &&
          source.dead &&
          source.dead.filter(item => item.count > 0).length > 0 && (
            <tr>
              <td
                colSpan="13"
                className="reason-badges"
                style={{
                  background: "#f8f9fa",
                  padding: "15px",
                }}
              >
                <div className="row">
                  <div className="col-12">
                    <strong className="text-danger mb-3 d-block fs-6 text-center">
                      Dead Reasons:
                    </strong>
                    <div className="d-flex flex-wrap justify-content-center">
                      {source.dead
                        .filter(item => item.count > 0)
                        .map((item, i) => (
                          <Link
                            key={i}
                            to={`/dead-leads?lead_source_id=${source.id}&dead_reason_id=${item.id}`}
                            className="badge bg-danger mx-1 mb-2 d-flex flex-column align-items-center"
                            title={item.reason}
                            style={{
                              fontSize: "11px",
                              textDecoration: "none",
                            }}
                          >
                            <span>
                              {item.count} {item.reason}
                            </span>
                            <small style={{ fontSize: "9px", opacity: 0.8 }}>
                              (
                              {(source.dead[0] && source.dead[0].total) > 0
                                ? (
                                    (item.count / source.dead[0].total) *
                                    100
                                  ).toFixed(1)
                                : 0}
                              %)
                            </small>
                          </Link>
                        ))}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          )}

        {/* Expanded rows for Dead Request reasons */}
        {showDetails2 &&
          source.dead_request &&
          source.dead_request.filter(item => item.count > 0).length > 0 && (
            <tr>
              <td
                colSpan="13"
                className="reason-badges"
                style={{
                  background: "#f8f9fa",
                  padding: "15px",
                }}
              >
                <div className="row">
                  <div className="col-12">
                    <strong className="text-warning mb-3 d-block fs-6 text-center">
                      Dead Request Reasons:
                    </strong>
                    <div className="d-flex flex-wrap justify-content-center">
                      {source.dead_request
                        .filter(item => item.count > 0)
                        .map((item, i) => (
                          <Link
                            key={i}
                            to={`/dead-requests?lead_source_id=${source.id}&dead_reason_id=${item.id}`}
                            className="badge bg-warning mx-1 mb-2 d-flex flex-column align-items-center"
                            title={item.reason}
                            style={{
                              fontSize: "11px",
                              textDecoration: "none",
                            }}
                          >
                            <span>
                              {item.count} {item.reason}
                            </span>
                            <small style={{ fontSize: "9px", opacity: 0.8 }}>
                              (
                              {(source.dead_request[0] &&
                                source.dead_request[0].total) > 0
                                ? (
                                    (item.count /
                                      source.dead_request[0].total) *
                                    100
                                  ).toFixed(1)
                                : 0}
                              %)
                            </small>
                          </Link>
                        ))}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          )}
      </>
    )
}
export default SourceList
